import axios from 'axios'

function createProductCard(product) {
  // product.title  - имя продукта
  // product.images - массив фоток, берем первые две
  // product.price  - цена, делим на 100 (data.price / 100)
  // product.url    - относительный урл
  const images = product.images
    .filter((_, index) => index < 2)
    .map((image) => {
      return `<picture><img src="${image}" alt="alt" loading="lazy"></picture>`
    })
    .join('')
  const price = product.price / 100
  return /*html*/ `
  <article class="product-card">
   <a class="double-image-hover product-card__image" href="${product.url}" rel="nofollow">
    ${images}
   </a>
   <div class="product-card__content">
      <div class="product-card__heading">
         <h3 class="heading-5 mb1-5"> <a href="${product.url}">${product.title}</a></h3>
         <div class="product-card__price">$ ${price}</div>
      </div>
      <a class="link" href="${product.url}" rel="nofollow">View Details</a>
   </div>
  </article>
  `
}

async function getProduct(handle) {
  const response = await axios({
    url:
      NODE_ENV === 'development'
        ? '/json/product.json'
        : `/products/${handle}.js`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  return response.data
}

/**
 *
 * @param {HTMLElement} swiperElement
 * @param {Array<String>} handles
 */
export async function createRecently(swiperElement, handles) {
  const productsRequests = []
  handles.forEach((handle) => {
    productsRequests.push(getProduct(handle))
  })
  const products = await Promise.all(productsRequests)
  const swiperWrapper = swiperElement.querySelector('.swiper-wrapper')
  swiperWrapper.innerHTML = products
    .map(createProductCard)
    .map((productCard) => `<div class="swiper-slide">${productCard}</div>`)
    .join('')
  return products
}
